<template>
    <div class="mainPage">
        <!-- <div class="header_banner">
            <img src="../img/classlive/m_banner.png" alt="" class="bg">
            <div class="header">
                <div class="titleCon">
                  <span class="title">
                    {{ $t('message.live') }}
                  </span>
                  <div class="memuCon">
                        <img src="../img/chinesebridge/menu.png" alt="" @click="toggleMenu()">
                        <div class="menu" v-show="activeMenu">
                            <div class="menuUserName" v-if="isLogin">{{user.username}}</div>
                            <div class="logOut" v-if="isLogin" @click="toLogOut()">退出</div>
                            <div class="menuUserName" v-if="!isLogin" @click="toLogin()">登录</div>
                            <div class="logOut" v-if="!isLogin" @click="toLogin()">注册</div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="left">
                        <div class="schoolInfo">
                            <div class="name">
                                {{subject_info.name}}
                            </div>
                            <div class="name_en" v-if="subject_info.name_en">
                                {{subject_info.name_en}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="bannerCon">
          <img src="../img/winter/m_banner.png" alt="">
        </div>
        <div class="content">
          <div class="moocCon">
            <h3>
              慕课 <span>Mooc</span>
            </h3>
            <div class="moocList">
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=446')">
                <div>
                  <img src="../img/winter/hsk_1.png" alt="">
                  <div class="title">
                    HSK标准会话教程（1级）
                  </div>
                </div>
                
              </div>
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=447')">
                <div>
                  <img src="../img/winter/hsk_2.png" alt="">
                  <div class="title">
                    HSK标准会话教程（2级）
                  </div>
                </div>
                
              </div>
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=136')">
                <div>
                  <img src="../img/winter/hanzi.png" alt="">
                  <div class="title">
                    《汉字五千年》[英文版]
                  </div>
                </div>
                
              </div>
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=94')">
                <div>
                  <img src="../img/winter/story.png" alt="">
                  <div class="title">
                    《中国历史常识》
                  </div>
                </div>
                
              </div>
              <div class="item" @click="tolive('https://mooc.chineseplus.net/dist/#/courseDetail?course_id=93')">
                <div>
                  <img src="../img/winter/culture.png" alt="">
                  <div class="title">
                    《中国文化常识》
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          <div class="courseListCon">
            <div>
              <h3>
                直播课 <span>Live Class</span>
              </h3>
            </div>
            <div class="tabCon">
              <span @click="isplayBack = false" :class="{'active': isplayBack == false}">
                直播 Live
              </span>
              <!-- <span  @click="currentStatus = 0" :class="{'active': currentStatus == 0}">
                预告
              </span> -->
              <span  @click="isplayBack = true" :class="{'active': isplayBack == true}">
                回放 Replay
              </span>
            </div>
            <ul class="list">
                <!-- <div v-if="currentStatus == 1 && !hasLive" class="noLive">
                  暂无直播
                </div> -->
                <li v-for="(item, index) in courseList" :key="item.id" :class="{'live': item.customStatus == 1, 'finished': item.customStatus == 2}" v-show="isplayBack == item.isplayBack">
                    <div class="timeCon" >
                        
                        <span class="status live" v-if="item.customStatus == 1">
                            Live 直播进行中
                        </span>
                        <span class="status finished" v-if="item.customStatus == 2">
                            Finished 直播已结束
                        </span>
                        <span class="status notice" v-if="item.customStatus == 0">
                            Notice 直播预告
                        </span>
                        <span class="time">{{new Date(+item.start_time).Format('YYYY.MM.DD hh:mm')}}-{{new Date(+item.end_time).Format('hh:mm')}}</span>
                    </div>
                    <div class="nameCon">
                        <div class="name name_en" v-if="item.name_en">
                            <span>
                                {{item.name_en}}
                            </span>
                        </div>
                        <div class="name" v-if="item.name">
                            <span>
                                {{item.name}}
                            </span>
                        </div>
                    </div>
                    <div class="titleCon">
                        <div class="title">
                            <div class="en" v-if="item.teacher_name_en">
                                {{item.teacher_name_en}}
                            </div>
                            <div class="cn" v-if="item.teacher_name">
                                {{item.teacher_name}}
                            </div>
                        </div>
                        <div class="liveBtn">
                            <span class="join" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                                <span class="En">
                                    Not open
                                </span>
                                <span class="Cn">
                                    未开放
                                </span>
                            </span>
                            <span class="join replay" v-if="item.status == 3" @click="replay(item.video_url, item.id)">
                                <span class="En">
                                    Replay
                                </span>
                                <span class="Cn">
                                    课程回放
                                </span>
                            </span>
                            <span class="isOrder" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == true">
                                直播未开始 Coming Soon
                            </span>
                            <span class="join" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                                <span class="En">
                                    Enter
                                </span>
                                <span class="Cn">
                                    进入
                                </span>
                            </span>
                        </div>
                    </div>
                </li>
                <div class="noMore">
                    <span>
                        没有更多了 No more  ...
                    </span>
                </div>
            </ul>
          </div>
          <div class="footer">
            <img src="../img/winter/winter_footer.png" alt="">
          </div>
        </div>
        <!-- <div class="footer">
          <img src="../img/winter/winter_footer.png" alt="">
        </div> -->
        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <!-- <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload"></video></div> -->
                <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload"></video></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
export default {
    name: 'chinesebridge',
    components: {
    },
    data: function () {
        return {
            activeMenu: false,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
            user: {
                username: '',
                email: ''
            },
            isplayBack: false,
            currentStatus: 0,
            subject_info: {},
            courseList: [],
            subject_id: null,
            beforeTime: 30, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    methods: {
        tolive (url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
                this.getCourseInfo(this.subject_id)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(alias) {
            this.$utils.get('/subject/subject/readbyalias', {
                alias
            }).then(res => {
                if(res.data.success) {
                    this.subject_info = res.data.data
                    this.getCourseInfo(this.subject_info.id)
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlist', {
                subject_id: id,
                limit: 200
            }).then(res => {
                if(res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    res.data.data.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        e.isplayBack = false
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                            
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                            e.isplayBack = true
                        }
                    })
                    this.courseList = res.data.data.list
                    this.checkOrdeList()
                }
            })
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set (this.courseList, index, this.courseList[index])
                        }
                    })
                }
            })
        },
        join(item, index, islive) {
            if (islive) {
                window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            }
            // if(!this.isLogin) {
            //     this.toLogin()
            //     return
            // }
            // const data = Qs.stringify({
            //     room_id: item.room_id,
            //     user: this.user.email,
            //     secret: "03198325b8b61ccc3413cf7e754febea",
            //     key: "zyz",
            //     username: this.user.username,
            //     realname: this.user.username
            // })
            // this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
            //     headers: {
            //         'Content-Type': 'application/x-www-form-urlencoded'
            //     }
            // }).then(res => {
            //     if (res.data.code == 0) {
            //         this.courseList[index].isOrder = true
            //         this.$set (this.courseList, index, this.courseList[index])
            //         if (islive) {
            //             window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            //         }
            //     }
            // })
        },
        joinToLive(item, index) {
          window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            // if(!this.isLogin) {
            //     this.toLogin()
            //     return
            // }
            // if(!item.isOrder) {
            //     this.join(item, index, true)
            // }else {
            //     window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            // }
        },
        replay(url, id) {
            // if(!this.isLogin) {
            //     this.toLogin()
            //     return
            // }
            // this.courseRecord(id)
            this.isPlay = true
            this.currentVideoUrl = url
        },
        // 回放观看记录
        courseRecord(id) {
            this.$utils.get('/subject/lesson/setrecord', {
                lesson_id: id
            })
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (!myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        toggleMenu() {
            this.activeMenu = !this.activeMenu
        }
    },
    mounted() {
        // this.subject_id = this.$route.query.id
        // this.customCheckLogin()
        this.getSubjectInfo('winter_olympics')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    height: 100%;
    font-size: 0;
    
    .header_banner {
        width: 100%;
        position: relative;
        overflow: hidden;
        .bg {
            width: 100%;
        }
        .header {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 1;
            text-align: left;
            .titleCon {
              line-height: 0.4rem;
            }
            .title {
              font-size: 0.38rem;
              color: #fff;
              margin-left: 0.48rem;
            }
            .memuCon {
                position: absolute;
                right: 0.33rem;
                top: 0.21rem;
                font-size: 0;
                z-index: 5;
                img {
                    width: 0.4rem;
                }
                .menu {
                    position: absolute;
                    right: 0;
                    top: 0.55rem;
                    background-color: #fff;
                    width: 100px;
                    border-radius: 0.05rem;
                    padding: 0.1rem 0;
                    font-size: 0.3rem;
                    div {
                        color: #333;
                        text-align: center;
                        line-height: 200%;
                    }
                }
            }
        }
    }
    .bannerCon {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .content {
      width: 100%;
      background-image: url(../img/winter/winter_bg_1.png);
      background-size: 100%;
      background-repeat: repeat;
      // min-height: 100%;
      font-size: 0;
      padding-left: 0.45rem;
      box-sizing: border-box;
      .noLive {
        color: #999;
        font-size: 0.3rem;margin-bottom: 0.4rem;
      }
      .moocCon {
        text-align: left;
        h3 {
          font-size: 0.52rem;
          display: inline-block;
          color: #0d0d0d;
          position: relative;
          margin-bottom: 0.3rem;
          margin-left: 0.2rem;
          &:before {
            content: '';
            display: inline-block;
            position: absolute;
            left: -0.2rem;
            width: 0.05rem;
            height: 0.48rem;
            background-color: #0c5fce;
          }
        }
        .moocList {
          white-space: nowrap;
          width: 100%;
          box-sizing: border-box;
          overflow-x: auto;
          .item {
            width: 4.5rem;
            height: 3.8rem;
            box-shadow: 0 0 14px 0 #95a8ad91;
            position: relative;
            border-radius: 5px;
            display: inline-block;
            margin-right: 0.15rem;
            img {
              width: 100%;
            }
            &:last-child {
              margin-right: 0.4rem;
            }
            cursor: pointer;
            .title {
              width: 100%;
              // height: 52px;
              line-height: 1rem;
              background-color: #fff;
              font-size: 0.36rem;
              color: #282828;
              text-indent: 0.5em;
            }
          }
        }
      }
      
    }
    .courseListCon {
        margin: auto;
        text-align: left;
        // background-color:#fff;
        .liveClass {
            padding-top: 0.25rem;
            width: 100%;
            text-align: center;
            img {
                width: 2.78rem;
            }
        }
        h3 {
          font-size: 0.52rem;
          display: inline-block;
          color: #0d0d0d;
          position: relative;
          margin-bottom: 0.42rem;
          margin-left: 0.2rem;
          margin-top: 0.6rem;
          &:before {
            content: '';
            display: inline-block;
            position: absolute;
            left: -0.2rem;
            width: 0.05rem;
            height: 0.48rem;
            background-color: #0c5fce;
          }
          .time {
            margin-left: 0.2rem;
            color: #999;
            font-size: 0.24rem;
          }
        }
        .tabCon {
          font-size: 0.39rem;
          color: #5b7aa2;
          margin-bottom: 0.4rem;
          span {
            margin-right: 1.1rem;
            cursor: pointer;
          }
          .active {
            color: #0c5fce;
          }
        }
        .list {
            position: relative;
            text-align: left;
            
            // &:before {
            //     position: absolute;
            //     left: 0.16rem;
            //     width: 0.08rem;
            //     height: calc(100% + 1rem);
            //     content: '';
            //     background-color: #7ecef4;
            // }
            li {
                width: calc(50% - 0.3rem);
                margin-right: 0.15rem;
                margin-bottom: 0.23rem;
                position: relative;
                background-color: #fff;
                display: inline-block;
                vertical-align: top;
                border-radius: 0.15rem;
                // &:before {
                //     position: absolute;
                //     left: -0.48rem;
                //     content: '';
                //     width: 0.24rem;
                //     height: 0.24rem;
                //     box-sizing: border-box;
                //     box-sizing: border-box;
                //     border-radius: 100%;
                //     border: 0.06rem solid #7ecef4;
                //     background-color: #fad46b;
                // }
                .timeCon {
                    font-size: 0;
                    padding-top: 0.1rem;
                    .time {
                        color: #5e696d;
                        font-family: "DIN-Medium";
                        vertical-align: top;
                        display: block;
                        margin-top: 0.38rem;
                        font-size: 0.33rem;
                        margin-left: 0.22rem;
                    }
                    .status {
                      padding: 0.08rem 0.22rem;
                      border-radius: 0.15rem 0 0.15rem 0;
                      font-size: 0.3rem;
                    }
                    .live {
                        background-color: rgba(#379346,0.5);
                        color: #fff;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }
                    .finished {
                        background-color: rgba(#93a4aa,0.5);
                        color: #fff;
                        vertical-align: middle;
                        font-family: "Georgia";
                    }
                    .notice {
                        background-color: rgba(#0c5fce,0.5);
                        color: #fff;
                    }
                }
                .nameCon {
                    margin-top: 0.26rem;
                    margin-bottom: 0.3rem;
                    font-size: 0.28rem;
                    margin-left: 0.22rem;
                    min-height: 1.2rem;
                    .name {
                        font-size: 0.28rem;
                        line-height: 1.2;
                        color: #364347;
                    }
                    .name_en {
                        font-size: 0.28rem;
                        line-height: 1.2;
                        color: #5e696d;
                        margin-bottom: 8px;
                        font-family: 'Georgia';
                    }
                }
                .titleCon {
                    font-size: 0.25rem;
                    // height: 0.6rem;
                    width: 100%;
                    .title {
                        color: #009dcd;
                        display: inline-block;
                        width: calc(100% - 2.5rem);
                        margin-left: 0.22rem;
                        margin-bottom: 0.3rem;
                        height: 0.76rem;
                        .en {
                            font-size: 0.25rem;
                            font-family: 'Georgia';
                            margin-bottom: 0.02rem;
                            width: 100%;
                            line-height: 1.2;
                        }
                        .cn {
                            font-size: 0.25rem;
                            width: 100%;
                            line-height: 1.2;
                        }
                    }
                    .liveBtn {
                        // float: right;
                        display: inline-block;
                        font-family: 'Georgia';
                        color: #282828;
                        height: 1.7rem;
                        line-height: 1.7rem;
                        text-align: center;
                        width: 100%;
                        background-color: #f6fafc;
                        .join {
                            display: inline-block;
                            height: 0.8rem;
                            width: 3rem;
                            line-height: 0.8rem;
                            border-radius: 0.28rem;
                            background-color: #fcb922;
                            box-sizing: border-box;
                            cursor: pointer;
                            .En {
                                font-size: 0.26rem;
                                vertical-align: top;
                            }
                            .Cn {
                                font-size: 0.24rem;
                                vertical-align: top;
                            }
                        }
                        .replay {
                            background-color: #7ecef4;
                        }
                        .isOrder {
                            color: #999;
                            font-size: 0.24rem;
                        }
                    }
                }
            }
            .live:before {
                background-color: #43fd61;
            }
            .finished:before {
                background-color: #d6e1e5;
            }
            .noMore {
                font-size: 0.25rem;
                margin-left: 0.4rem;
                color: #7ecef4;
                position: relative;
            }
            .noMore:after {
                position: absolute;
                right: 0;
                z-index: 1;
                top: 0.18rem;
                display: inline-block;
                content: '';
                height: 0.03rem;
                width: calc(100% - 2.8rem);
                background-color: #7ecef4;
            }
        }
    }
    .footer {
      width: calc(100% + 0.45rem);
      margin-left: -0.45rem;
      
      img {
        width: 100%;
      }
    }
    #videoPlayWrapper {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 999;
        }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .videoContainer {
        text-align: center;
        width: 100%;
    }
    .videoContainer video {
        width: 100%;
    }
}

</style>
